export default __webpack_public_path__ + "static/media/fios-04.70a2a8c3.jpg";